import usePreview3DStore from 'src/components/widgets/preview3D/store';

export default function useMeshSides() {
    const [zkProduct, sceneManager] = usePreview3DStore((x) => [x.zkProduct, x.sceneManager]);

    const isVariantConfigured = (variantId: number) => {
        const modelColor = zkProduct?.get('colors').get(variantId)!;

        // Get the mesh side for variant only if the variant has a custom model
        // otherwise fallback to mesh side per product
        const meshSideVariantID = sceneManager?.hasVariantCustomModel(modelColor) ? variantId : null;

        return (
            zkProduct
                ?.get('scenes')
                .at(0)
                ?.get('meshSides')
                .toArray()
                .some((x) => x.get('colorID') === meshSideVariantID) ?? false
        );
    };

    const getMeshSide = (variantId: number, sideId: number) => {
        const modelColor = zkProduct?.get('colors').get(variantId)!;

        // Get the mesh side for variant only if the variant has a custom model
        // otherwise fallback to mesh side per product
        const meshSideVariantID = sceneManager?.hasVariantCustomModel(modelColor) ? variantId : null;

        // First get the mesh side specific for this variant and side
        const meshSide = zkProduct
            ?.get('scenes')
            .at(0)
            ?.get('meshSides')
            .find((x) => x.get('colorID') === meshSideVariantID && x.get('sideID') === sideId);

        return meshSide;
    };

    const createMeshSide = (variantId: number, sideId: number) => {
        const modelColor = zkProduct?.get('colors').get(variantId)!;

        // Get the mesh side for variant only if the variant has a custom model
        // otherwise fallback to mesh side per product
        const meshSideVariantID = sceneManager?.hasVariantCustomModel(modelColor) ? variantId : null;

        const meshSide = new MPlaza.ModelSceneMeshSide({
            sideID: sideId,
            colorID: meshSideVariantID
        });

        zkProduct?.get('scenes').at(0)?.get('meshSides').add(meshSide);

        return meshSide;
    };

    return {
        getMeshSide,
        createMeshSide,
        isVariantConfigured
    };
}
